/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Eye',
  definitions: {
    '24': {
      viewBox: '0 0 24 24',
      path: (
        <>
          <g id="Icon">
            <g id="Path">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 7.17505C9.33871 7.17505 7.17501 9.33875 7.17501 12C7.17501 14.6613 9.33871 16.8251 12 16.8251C14.6613 16.8251 16.825 14.6613 16.825 12C16.825 9.33875 14.6613 7.17505 12 7.17505ZM8.82501 12C8.82501 10.25 10.25 8.82505 12 8.82505C13.75 8.82505 15.175 10.25 15.175 12C15.175 13.7501 13.75 15.175 12 15.175C10.25 15.175 8.82501 13.7501 8.82501 12Z"
                fill="currentColor"
              />
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.4141 10.5726C19.2551 6.8046 15.6834 4.80005 12 4.80005C8.31659 4.80005 4.74491 6.8046 1.58589 10.5726C0.893856 11.3981 0.893854 12.602 1.58589 13.4274C4.74491 17.1955 8.31659 19.2 12 19.2C15.6834 19.2 19.2551 17.1955 22.4141 13.4274C23.1062 12.602 23.1062 11.3981 22.4141 10.5726ZM2.85032 11.6327C5.81434 8.09725 8.96304 6.45005 12 6.45005C15.037 6.45005 18.1857 8.09725 21.1497 11.6327C21.3276 11.8449 21.3276 12.1551 21.1497 12.3674C18.1857 15.9028 15.037 17.55 12 17.55C8.96304 17.55 5.81434 15.9028 2.85032 12.3674C2.67238 12.1551 2.67238 11.8449 2.85032 11.6327Z"
                fill="currentColor"
              />
            </g>
          </g>
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
